<template>
  <div>
    <form @submit.prevent="onUpload">
      <div class="form-group">
        <input
          type="file"
          name="imagesArray"
          multiple
          @change="onChange"
          :v-model="imagesArray"
        />
      </div>
      <div class="form-group">
        <button class="btn btn-success" :disabled="loading">
          <span v-show="loading" class="spinner-border spinner-border-sm"></span
          >Upload Files
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import API from "@/services/index.js";

export default {
  props: ["apiPath", "transId"],
  data() {
    return {
      imagesArray: null,
      token: "Bearer " + localStorage.getItem("token"),
      loading: false,
    };
  },
  methods: {
    onChange(event) {
      this.imagesArray = event.target.files;
    },
    onUpload() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      if (this.imagesArray == null) {
        Toast.fire({
          icon: "error",
          title: "Please upload atleast one file",
        });
        return false;
      }
      this.loading = true;
      const formData = new FormData();
      for (const i of Object.keys(this.imagesArray)) {
        formData.append("files[]", this.imagesArray[i]);
      }

      formData.append("id", this.transId);
      console.log(this.imagesArray);
      API.post(this.apiPath, formData, {
        headers: { Authorization: this.token },
      }).then((res) => {
        console.log(res);
        this.loading = false;
        if (res.data.status == 200) {
          Toast.fire({
            icon: "success",
            title: res.data.messages,
          });
          //window.location.reload();
        } else {
          //var ErrorText = "";
          let error = JSON.stringify(res.data.messages);
          Toast.fire({
            icon: "error",
            title: error,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="css">
.container {
  max-width: 550px;
}
</style>